// extracted by mini-css-extract-plugin
module.exports = {"container":"Quote_container__VP7sZ","icon":"Quote_icon__QNLMA","quote":"Quote_quote__hEgfm","text":"Quote_text__lxwyS"};